<template>
    <div class="d-flex justify-content-around w-100 stepper">
        <div v-for="step in steps">
            <div class="text-center rounded-step" :class="{'current': currentStep === step.index}">{{ step.index }}</div>
            <div class="text-center font-weight-bold text">{{ step.label }}</div>
        </div>
    </div>
</template>

<script>
export default {
    name: "Stepper",
    props: ['steps', 'currentStep']
}
</script>